import type { ComponentProps } from 'react'
import { clsx } from 'clsx'

/** An inline text link in the accent colour, for a quiet next step. */
export function TextLink({ className, children, ...props }: ComponentProps<'a'>) {
  return (
    <a
      className={clsx(
        'inline-flex min-h-6 items-center rounded-xs text-sm font-medium text-accent-500',
        'underline underline-offset-2 hover:no-underline focus-visible:focus-ring',
        className
      )}
      {...props}
    >
      {children}
    </a>
  )
}
